/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Form_RoleInputs */

const en_cp_form_role = /** @type {(inputs: Cp_Form_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your role`)
};

const id_cp_form_role = /** @type {(inputs: Cp_Form_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peran Anda`)
};

/**
* | output |
* | --- |
* | "Your role" |
*
* @param {Cp_Form_RoleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_form_role = /** @type {((inputs?: Cp_Form_RoleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Form_RoleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_form_role(inputs)
	return en_cp_form_role(inputs)
});